import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import {
    faChevronLeft,
    faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ReactPaginate from 'react-paginate';
import Delete from '../../Components/Buttons/Delete';
import Edit from '../../Components/Buttons/Edit';
import Text from '../../Components/Text';
import TextDate from '../../Components/TextDate';
import Sublist from '../List/Sublist';

import paginationStyle from '../../../../scss/components/paginator/paginator.module.scss';
import usePagination from '../../../Hooks/usePagination';
import TextResource from '../../Components/TextResource';

const ProductReviews = ({ service, entity: productEntity }) => {
    const [reviews, setReviews] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const {
        currentPage,
        currentPageIndex,
        totalPages,
        changePage,
        updateTotalItems,
        itemsPerPage,
    } = usePagination({
        totalItemsCount: 0,
        itemsPerPage: 20,
    });
    // TODO Check filtering by product_id
    const getReviews = () => {
        setIsLoading(() => true);
        service
            .get('reviews', {
                'filter[product_id]': productEntity.id,
                page: currentPage,
                per_page: itemsPerPage,
            })
            .then((data) => {
                setReviews(data.data);
                updateTotalItems(data.meta.total);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        getReviews();
    }, []);

    useEffect(() => {
        getReviews();
    }, [currentPage]);

    if (isLoading) {
        return (
            <div className="flex items-center justify-center space-y-4 mb-16">
                <TextResource
                    resource="reviews"
                    name="loading"
                    className="text-3xl mb-8"
                />
            </div>
        );
    }

    return (
        <div className="flex flex-col space-y-4 mb-16">
            <Sublist
                service={service}
                resource="reviews"
                entity={reviews}
                onDelete={getReviews}
            >
                <Edit name="id" />
                <TextDate name="created_at" />
                <Delete name="delete" list />
                <Text
                    name="description"
                    isParagraph
                    className="max-w-2xl truncate"
                />
            </Sublist>

            <ReactPaginate
                forcePage={currentPageIndex}
                pageCount={totalPages}
                pageRangeDisplayed={4}
                marginPagesDisplayed={0}
                renderOnZeroPageCount={null}
                onPageChange={changePage}
                className={paginationStyle.paginationContainer}
                pageClassName={paginationStyle.paginationPage}
                activeClassName={paginationStyle.paginationPageActive}
                previousClassName={paginationStyle.paginationPage}
                nextClassName={paginationStyle.paginationPage}
                pageLinkClassName={paginationStyle.paginationPageLink}
                nextLinkClassName={paginationStyle.paginationPageLink}
                previousLinkClassName={paginationStyle.paginationPageLink}
                breakClassName="hidden"
                disabledClassName="opacity-40"
                previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
                nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
            />
        </div>
    );
};

export default ProductReviews;

ProductReviews.propTypes = {
    /**
     * Type of service
     */
    service: PropTypes.object.isRequired,
    /**
     * Type of entity
     */
    entity: PropTypes.object.isRequired,
};
